export default {
  GET_ACTIVITY_INSTANCES_REQUEST: 'GET_ACTIVITY_INSTANCES_REQUEST',
  GET_ACTIVITY_INSTANCES_SUCCESS: 'GET_ACTIVITY_INSTANCES_SUCCESS',
  GET_ACTIVITY_INSTANCES_FAILURE: 'GET_ACTIVITY_INSTANCES_FAILURE',

  SET_CURRENT_INSTANCE: 'SET_CURRENT_INSTANCE',
};
